import {axios,get,post} from "./request"

// 前端写的请求
export const ajax = {
    apiText:(params)=>get('./api/test',params),

    register:(params)=>post('/api/token/register/',params), // 注册
    reUser:(params)=>post('/api/userprofile/person/',params), // 用户名信息
    reBuyer:(params)=>get('/api/Buyer',params), // 采购方
    reSeller:(params)=>post('/api/product/get_product_page/',params), // 供应方
    commodity:(params)=>post('/api/product/get_product_factory_list/',params), // 工厂和基地
    commodityParticulars:(id,params)=>post('/api/product/'+id +'/get_product_detail/',params), // 工厂和基地详情
    submitOrder:(id,params)=>post('/api/product/'+id +'/checkout_product/',params), // 提交订单
    shoppingList:(params)=>post('/api/shoppingList/get_list_ids/',params), // 购物车列表
    orderList:(params)=>post('/api/order/get_order_list/',params), // 订单列表
    shoppingListId:(params)=>post('/api/shoppingList/get_list_id/',params), // 购物车列表id
    addShoppingList:(params)=>post('/api/shoppingList/add_my_list/',params), // 加入购物车
    token:(params)=>post('/api/token/',params), // 登录
    shoppingListMy:(params)=>post('/api/shoppingList/get_my_list/',params), // 购物车列表
    editShoppingList:(params)=>post('/api/shoppingList/edit_number/',params), // 修改购物车数量
    wipeShoppingList:(params)=>post('/api/shoppingList/wipe_my_list/',params), // 清空购物车
    checkoutShoppingList:(params)=>post('/api/shoppingList/checkout_my_list/',params), // 提交采购
    shoppingListIds:(params)=>post('/api/shoppingList/get_list_ids/',params), // 获取购物车id
    
}